import React, { lazy, useEffect, useState } from "react";
import DateRangePicker from "react-bootstrap-daterangepicker";
import Moment from "moment";
import { format, subDays } from "date-fns";
import { Card, CardBody, CardHeader } from "../../components/card/card.jsx";
import "bootstrap-daterangepicker/daterangepicker.css";
import StructureView from "./structure_view";
import Accordion from "react-bootstrap/Accordion";
import { machineProfile } from "../../api";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import { useDashboardContext } from "../../contexts/NewDashboardContext";
import LiveChart from "../../pages/sensor/LiveChart";

const getStatus = (status) => {
  switch (status) {
    case "Acceptable":
      return "accept";
    case "Observe":
      return "observe";
    case "Alert":
      return "alert";
    case "Critical":
      return "critical";
    default:
      return "pending";
  }
};

function ReportData({ machineId, pastMachineHealth }) {
  console.log({ pastMachineHealth });
  // get latest Wednesday date
  const lastWednesday = Moment().day(-4).format("YYYY-MM-DD");
  const nextWeek = Moment(lastWednesday).add(7, "days").format("YYYY-MM-DD");
  // get remaining days and hours example 3 days and 2 hour left for next update
  const remainingDays = Moment(nextWeek).fromNow();
  const [reportDate, setReportDate] = useState(null);
  const [reportDate2, setReportDate2] = useState(null);
  const { weeklyAnalytics, updateWeeklyAnalytics } = useDashboardContext();
  const [loading, setLoading] = useState(false);
  const [machineDetail, setMachineDetail] = useState(null);
  const [selectedMachine, setSelectedMachine] = useState(null);
  const [activeKey, setActiveKey] = useState(null);
  const [key, setKey] = useState("tab0");
  const [selectedMachineHealth, setSelectedMachineHealth] = useState(null);
  const [selectedMachineHealth2, setSelectedMachineHealth2] = useState(null);
  const [selectedMachineHealthId, setSelectedMachineHealthId] = useState(null);
  const [selectedMachineHealthId2, setSelectedMachineHealthId2] =
    useState(null);
  const [machineHealth, setMachineHealth] = useState([]);
  const [lastMachineHealth, setLastMachineHealth] = useState([]);
  var dateRange = {
    currentWeek:
      Moment().subtract(7, "days").format("D MMM YYYY") +
      " - " +
      Moment().format("D MMM YYYY"),
    prevWeek:
      Moment().subtract(15, "days").format("D MMM") +
      " - " +
      Moment().subtract(8, "days").format("D MMM YYYY"),
  };

  var startDate = "";
  var endDate = "";
  var prevDate = Moment().add(-1, "d").format("D MMM YYYY");
  var todayDate = Moment().add(-1, "d").format("D MMM YYYY");
  useEffect(() => {
    if (machineId) {
      getMachine();
    }
    // getMachine();
  }, [machineId]);
  const getMachine = async () => {
    try {
      setLoading(true);
      const res = await machineProfile.getOne(machineId);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        setMachineDetail(data);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };
  const getSensors = () => {
    const sensors = [];
    if (machineDetail && machineDetail.machine_elements) {
      machineDetail.machine_elements.map((me) => {
        if (me.deployments) {
          me.deployments.map((d) => {
            let sensor = d.sensor;
            sensor.machine_element_name = me.machine_element_name;
            sensor.machine_element_id = me.id;
            sensor.deployments_id = d.id;
            sensors.push(sensor);
          });
        }
      });
    }
    console.log({ sensors });
    return sensors;
  };
  useEffect(() => {
    if (key) {
      updateWeeklyAnalytics({ sensor: key });
    }
  }, [key]);
  useEffect(() => {
    if (weeklyAnalytics.sensor) {
      setKey(weeklyAnalytics.sensor);
    }
  }, [weeklyAnalytics]);

  useEffect(() => {
    if (pastMachineHealth.length === 1) {
      setSelectedMachineHealthId(pastMachineHealth[0].created_at);
      setSelectedMachineHealthId2(pastMachineHealth[0].created_at);
      setSelectedMachineHealth(pastMachineHealth[0]);
      setSelectedMachineHealth2(pastMachineHealth[0]);
    }
    if (pastMachineHealth.length > 2) {
      setSelectedMachineHealthId(pastMachineHealth[0].created_at);
      setSelectedMachineHealthId2(pastMachineHealth[1].created_at);
      setSelectedMachineHealth2(pastMachineHealth[1]);
      setSelectedMachineHealth(pastMachineHealth[0]);
    }
  }, []);

  useEffect(() => {
    if (selectedMachineHealthId) {
      const selected = pastMachineHealth.find(
        (mh) => mh.created_at === selectedMachineHealthId
      );
      setSelectedMachineHealth(selected);
    }
  }, [selectedMachineHealthId]);
  useEffect(() => {
    if (selectedMachineHealthId2) {
      const selected = pastMachineHealth.find(
        (mh) => mh.created_at === selectedMachineHealthId2
      );
      setSelectedMachineHealth2(selected);
    }
  }, [selectedMachineHealthId2]);

  useEffect(() => {
    if (selectedMachineHealth) {
      setReportDate(null);
      setTimeout(() => {
        const weekBefore = Moment(selectedMachineHealth.created_at)
          .subtract(7, "days")
          .format("YYYY-MM-DD");
        const weekNow = Moment(selectedMachineHealth.created_at).format(
          "YYYY-MM-DD"
        );
        setReportDate({ startDate: weekBefore, endDate: weekNow });
      }, 400);
    }
  }, [selectedMachineHealth]);
  useEffect(() => {
    if (selectedMachineHealth2) {
      setReportDate2(null);
      setTimeout(() => {
        const weekNow2 = Moment(selectedMachineHealth2.created_at).format(
          "YYYY-MM-DD"
        );
        const weekBefore2 = Moment(selectedMachineHealth2.created_at)
          .subtract(7, "days")
          .format("YYYY-MM-DD");
        setReportDate2({ startDate: weekBefore2, endDate: weekNow2 });
      }, 400);
    }
  }, [selectedMachineHealth2]);

  useEffect(() => {
    if (reportDate) {
      getHealth();
    }
  }, [reportDate]);
  useEffect(() => {
    if (reportDate2) {
      getHealth2();
    }
  }, [reportDate2]);

  const getHealth2 = async () => {
    const result2 = await machineProfile.listMachineHealth({
      start_date: reportDate2.startDate,
      end_date: reportDate2.endDate,
      machine_id: machineId,
    });
    if (result2.ok) {
      const body = await result2.json();
      if (body.data.length) {
        setLastMachineHealth(body.data);
      } else {
        setLastMachineHealth([]);
      }
    }
  };
  const getHealth = async () => {
    let start = "";
    let end = "";
    // start last week in format YYYY-MM-DD
    // end today in format YYYY-MM-DD

    const result = await machineProfile.listMachineHealth({
      start_date: reportDate.startDate,
      end_date: reportDate.endDate,
      machine_id: machineId,
    });

    if (result.ok) {
      const body = await result.json();
      if (body.data.length) {
        setMachineHealth(body.data);
      } else {
        setMachineHealth([]);
      }
    }
  };

  const MachineHealthDetail = ({ data }) => {
    return (
      <Card className="border-theme mb-3 mt-3">
        <CardHeader className="border-theme fw-bold small text-theme d-flex">
          <div className="flex-1">
            <span
              className={`badge bg-${getStatus(data.status)}`}
              style={{ color: "black" }}
            >
              {data.status}
            </span>{" "}
            Machine Health
          </div>
          <div>
            {" "}
            {format(new Date(data.created_at), "dd MMMM yyyy | HH:mm ")}
          </div>
        </CardHeader>
        <CardBody>
          <p
            className="card-text text-opacity-75"
            style={{ whiteSpace: "pre-wrap" }}
          >
            {data.description}
          </p>
        </CardBody>
      </Card>
    );
  };

  function handleDateApplyEvent(event, picker) {
    var startDate = picker.startDate;
    var endDate = picker.endDate;
    var gap = endDate.diff(startDate, "days");

    var currentWeek =
      startDate.format("D MMM YYYY") + " - " + endDate.format("D MMM YYYY");
    var prevWeek =
      Moment(startDate).subtract(gap, "days").format("D MMM") +
      " - " +
      Moment(startDate).subtract(1, "days").format("D MMM YYYY");

    dateRange.currentWeek = currentWeek;
    dateRange.prevWeek = prevWeek;
  }

  const onChangeTree = (ms) => {
    setActiveKey(null);
    setSelectedMachine(ms);
  };

  const toggleAccordion = () => {
    if (activeKey === "0") {
      setActiveKey(null);
    } else {
      setActiveKey("0");
    }
  };

  return (
    <div>
      <div className="row" style={{ position: "relative", zIndex: "1" }}>
        <div className="col-6">
          <select
            className="form-select btn btn-sm btn-outline-theme form-select-sm"
            value={selectedMachineHealthId}
            onChange={(e) => setSelectedMachineHealthId(e.target.value)}
            defaultValue="Index"
          >
            <option value="">- Choose Machine Health Analysis -</option>
            {pastMachineHealth.map((mh, i) => (
              <option value={mh.created_at} key={i}>
                {format(new Date(mh.created_at), "dd MMMM yyyy")} ({mh.status})
              </option>
            ))}
          </select>
          {selectedMachineHealth ? (
            <div className="mt-3">
              <MachineHealthDetail
                data={selectedMachineHealth}
                filteredDate={selectedMachineHealth.created_at}
              />

              {reportDate ? (
                <Card className="mb-4">
                  <CardHeader>
                    Live Sensor Data{" "}
                    {format(
                      subDays(new Date(selectedMachineHealth.created_at), 7),
                      "dd MMMM yyyy"
                    )}{" "}
                    -{" "}
                    {format(
                      new Date(selectedMachineHealth.created_at),
                      "dd MMMM yyyy"
                    )}
                  </CardHeader>
                  <CardBody>
                    <Tabs
                      id="controlled-tab-example"
                      activeKey={key}
                      onSelect={(k) => setKey(k)}
                      className="mb-3"
                    >
                      {getSensors().map((item, index) => {
                        return (
                          <Tab
                            eventKey={"tab" + index}
                            title={item.machine_element_name}
                          >
                            {/*        /!*only render if key are active*!/*/}
                            {key == "tab" + index && (
                              <LiveChart
                                filteredDate={reportDate}
                                onlyVibration={true}
                                sensorData={item}
                                machineId={machineId}
                                machineDetail={machineDetail}
                              />
                            )}
                          </Tab>
                        );
                      })}
                    </Tabs>
                  </CardBody>
                </Card>
              ) : null}
            </div>
          ) : null}
        </div>
        <div className="col-6">
          <select
            className="form-select btn btn-sm btn-outline-theme form-select-sm"
            value={selectedMachineHealthId2}
            onChange={(e) => setSelectedMachineHealthId2(e.target.value)}
            defaultValue="Index"
          >
            <option value="">- Choose Machine Health Analysis -</option>
            {pastMachineHealth.map((mh, i) => (
              <option value={mh.created_at} key={i}>
                {format(new Date(mh.created_at), "dd MMMM yyyy")} ({mh.status})
              </option>
            ))}
          </select>
          <div className="mt-3">
            {selectedMachineHealth2 ? (
              <MachineHealthDetail
                data={selectedMachineHealth2}
                filteredDate={selectedMachineHealth2.created_at}
              />
            ) : null}
            {reportDate2 ? (
              <Card className="mb-4">
                <CardHeader>
                  Live Sensor Data{" "}
                  {format(
                    subDays(new Date(selectedMachineHealth2.created_at), 7),
                    "dd MMMM yyyy"
                  )}{" "}
                  -{" "}
                  {format(
                    new Date(selectedMachineHealth2.created_at),
                    "dd MMMM yyyy"
                  )}
                </CardHeader>
                <CardBody>
                  <Tabs
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                    className="mb-3"
                  >
                    {getSensors().map((item, index) => {
                      return (
                        <Tab
                          eventKey={"tab" + index}
                          title={item.machine_element_name}
                        >
                          {/*        /!*only render if key are active*!/*/}
                          {key == "tab" + index && (
                            <LiveChart
                              filteredDate={reportDate2}
                              onlyVibration={true}
                              sensorData={item}
                              machineId={machineId}
                              machineDetail={machineDetail}
                            />
                          )}
                        </Tab>
                      );
                    })}
                  </Tabs>
                </CardBody>
              </Card>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReportData;
